









































































import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import CustomViews from "@/components/cost/CustomViews.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { ReportGoToHelper } from "@/lib/utility/report.go-to-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { ReportGroup, IReportGroup } from "@/models/report-group.entity";
import { IReport, Report } from "@/models/report.entity";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { ReportGroupModule } from "@/store/modules/report-group.store";
import { mixins } from "vue-class-component";
import { Component, Ref } from "vue-property-decorator";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import PartnerReportDetailSideCard from "@/components/partner/PartnerReportDetailSideCard.vue";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { IVehicle } from "@/models/vehicle.entity";
import RefsVehicle from "@/components/utility/RefsVehicle.vue";
import { VehicleTabs } from "@/lib/enum/vehicle-tabs.enum";
import { simpleDoubleDigitDate, formatHoursAndMinutes } from "@/lib/utility/date-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ProjectCustomViewTypeEnum } from "@/views/project/enum/ProjectCustomViewTypeEnum";
import { ProjectCustomViewFieldEnum } from "@/views/project/enum/ProjectCustomViewFieldEnum";
import { MrfiktivReportGroupControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import RefsReportGroup from "@/components/utility/RefsReportGroup.vue";
import AssigneePreview from "@/components/utility/AssigneePreview.vue";
import { getNestedObjectValues, propertiesToArray } from "@/lib/objectPath-helper";
import { ReportPaginationModule } from "@/store/modules/report-pagination.store";
import ReportCreateDialog from "@/components/partner/ReportCreateDialog.vue";

@Component({
  components: {
    MHeader,
    CustomViews,
    TheLayoutPortal,
    LatestEntriesCardEmpty,
    PartnerReportDetailSideCard,
    RefsVehicle,
    ReportCreateDialog,
    AssigneePreview,
    RefsReportGroup
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ReportGroupCustomViewView extends mixins(PartnerFallbackMixin, PermissionMixin) {
  @Ref("reportDialog")
  reportDialog!: ReportCreateDialog;

  @Ref("customViews")
  customViews!: CustomViews<IReport, MrfiktivReportGroupControllerGetParamsGen>;

  readonly store = ReportPaginationModule;

  readonly BackendResourceEnum = BackendResourceEnum;

  readonly getNestedObjectValues = getNestedObjectValues;

  readonly propertiesToArray = propertiesToArray;

  isLoading = false;

  reportGroup: IReportGroup | null = null;

  isDialogActive = false;

  viewId = "0";

  partnerId = this.$route.params.partnerId;

  reportGroupId = this.$route.params.reportGroupId;

  selectedItem: IReport | null = null;

  tableBaseConfig = {
    values: [
      {
        type: ProjectCustomViewFieldEnum.PROPERTY,
        key: "titleReadable"
      }
    ],
    filters: []
  };

  calendarBaseConfig = {
    calendarStart: {
      type: ProjectCustomViewFieldEnum.PROPERTY,
      key: "date"
    },
    filters: []
  };

  boardBaseConfig = {
    filters: []
  };

  originalHiddenFilters: IPageFilterElement[] = [];

  get viewIdLocal() {
    return this.viewId;
  }

  set viewIdLocal(value: string) {
    this.viewId = value;

    this.closeSideCard();
  }

  get breadCrumbList(): IBreadcrumb[] {
    const breadCrumbs = ReportGoToHelper.breadCrumbs;
    const crumbs: IBreadcrumb[] = [breadCrumbs.ReportGroupTable(this.partnerId)];
    if (this.reportGroup?.id) {
      crumbs.push(breadCrumbs.ReportGroupCustomView(this.partnerId, this.reportGroup.id));
    }

    return crumbs;
  }

  get chips(): IAction[] {
    const chips: IAction[] = [];

    if (this.reportGroup?.isDefault) {
      chips.push({
        key: "isDefault",
        text: $t("objects.reportGroup.isDefault")
      });
    }

    return chips;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.canCreateReport) {
      actions.push({
        text: $t("report.createReport"),
        key: "createReport",
        exec: () => this.reportDialog.open()
      });
    }

    if (this.reportGroup?.configuration.views[Number(this.viewIdLocal)]?.type === ProjectCustomViewTypeEnum.TABLE) {
      actions.push({
        text: $t("common.verbs.download").toString(),
        key: "download",
        exec: () => this.customViews.downloadToCsv()
      });
    }

    if (this.can(this.ActionEnum.UPDATE, this.ResourceEnum.REPORT_GROUP)) {
      actions.push({
        icon: "mdi-pencil",
        text: $t("project.ticket.settings"),
        key: "edit",
        exec: this.goToSettings
      });
    }

    return actions;
  }

  beforeMount() {
    this.partnerId = this.$route.params.partnerId;
    this.reportGroupId = this.$route.params.reportGroupId;
    this.viewId = this.$route.params.viewId ?? "0";
  }

  async mounted() {
    this.isLoading = true;
    try {
      const partnerAsync = this.trySetByRouteOrDefault();
      const reportGroupAsync = (
        ReportGroupModule.maps.id.get(this.reportGroupId)[0] ??
        new ReportGroup({
          id: this.reportGroupId,
          partnerId: this.partnerId
        })
      )
        .fetch()
        .then(reportGroup => (this.reportGroup = reportGroup));

      await Promise.all([partnerAsync, reportGroupAsync]);

      this.originalHiddenFilters = [...(this.store.hiddenFilter ?? [])];
      this.store.setHiddenFilter([
        ...this.originalHiddenFilters,
        new PageFilterElement({ key: "groupId", operation: "$eq", value: this.reportGroupId })
      ]);
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }

    const reportId = this.$route.query.reportId as string;
    if (reportId) {
      const report = new Report({ partnerId: this.partnerId, id: reportId });
      this.openSideCard(report);
    }
  }

  beforeDestroy() {
    this.store.setHiddenFilter([...this.originalHiddenFilters]);
  }

  goToSettings() {
    new ReportGoToHelper(this.$router).goToReportGroupDetail({
      partnerId: this.partnerId,
      reportGroupId: this.reportGroupId
    });
  }

  async getReportGroup(id: string) {
    if (!id) return;
    let reportGroup = ReportGroupModule.maps.id.get(id)[0];
    if (!reportGroup) {
      reportGroup = new ReportGroup({ partnerId: this.partnerId, id });
      reportGroup.fetch();
    }

    return reportGroup;
  }

  goToReportGroupDetail(reportGroupId: string) {
    new ReportGoToHelper(this.$router).goToReportGroupDetail({
      partnerId: this.partnerId,
      reportGroupId: reportGroupId
    });
  }

  createReport() {
    this.reportDialog?.open();
  }

  // identify strings formatted as NNNN-NN-NNTNN:NN
  isDayTimeString(value: string) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value);
  }

  getDateTime(value: string) {
    return simpleDoubleDigitDate(value) + " " + formatHoursAndMinutes(new Date(value));
  }

  goToVehicleDetail(vehicle: IVehicle) {
    new GoToHelper(this.$router).goToVehicleDetail(vehicle.id, vehicle.partnerId, VehicleTabs.HOME, true);
  }

  closeSideCard() {
    this.selectedItem = null;

    new ReportGoToHelper(this.$router).setUrl(
      ReportGoToHelper.locations.reportGroupCustomView({
        partnerId: this.partnerId,
        reportGroupId: this.reportGroupId,
        viewId: this.viewIdLocal || "0"
      })
    );
  }

  openSideCard(report: IReport) {
    this.selectedItem = null;
    this.$nextTick(() => {
      this.selectedItem = report;
      new ReportGoToHelper(this.$router).setUrl(
        ReportGoToHelper.locations.reportGroupCustomView({
          partnerId: this.partnerId,
          reportGroupId: this.reportGroupId,
          viewId: this.viewIdLocal || "0",
          query: report ? { reportId: report.id } : {}
        })
      );
    });
  }

  toArray<T>(value: T | T[]): T[] {
    if (!value) {
      return [];
    }

    if (!Array.isArray(value)) {
      return [value];
    }

    return value;
  }
}
